import {IOwayoDataModel, OwayoDataModel} from "../model";
import {ISelObInfoProvider, ISnapshotTaker} from "../owayoJSViewerWithSelObs";
import {EventVerteiler} from "../../global/eventVerteiler";
import {ResourceInvalidationTriggers} from "../../global/resourcemanager/resourceManager";
import {CONTROLLER_EVENTNAMES, GLOBALEVENTNAMES, SELOBTAB_EVENTNAMES} from "../../global/GlobalEventnames";
import {OwayoKonfiPart} from "../owayoPartWithSelObs";
import {PatternAnkerContainer} from "../pattern/partPatternContainer";
import {ColorController} from "./colorController";
import {ChromoLogo, ChromoLogoColor, Logo, SelectableObject, StockLogo, TextObject} from "../selectableObjects";
import {SelObTypes} from "../SelObTypes";
import {Product} from "../product";
import {Color} from "../colorObject";
import {PatternInEntwurf} from "../pattern/patternEntwurfsobjektInteractor";
import globalsObject, {translate} from "../globalsObject";
import {EntwurfFromDB} from "../databaseInterfaceClasses";
import {Entwurf} from "../entwurfsObjekt";
import {ProduktListe} from "../produktListe";
import {arrayElementByKeyValue, arrayIndexByKeyValue} from "../../global/arrayHelper";
import {boolToInt} from "../../global/globalUtils";
import DEBUG from "../DEBUG";
import {CONSTANTS} from "../meta_data";
import {DIALOGS} from "../../global/dialogDefinitions";
import {ColorUtils} from "../colorUtils";
import {ProductController} from "../produktController";
import {Screenblocker} from "../../global/Screenblocker";
import {PPIInfo} from "./selObController";

type LogoDataForBoundaryCrossing = {
    name,
    part,
    pathToLogo,
    point,
    rotation,
    relSize,
    zIndex,
    chromoLogoId,
    logoId,
    stockLogoID,
    repeat,
    clampToColor,
    wasserzeichen,
    wasserzeichenInvertImage,
    wasserzeichenIntensity,
    isPinned,
    floating,
    keepSeparate,
    allowDrag,
    allowDelete,
    allowResize,
    allowColorChange,
    colors,
    isEinfaerbbar,
    isVorbelegung,
    ursprungsMotivID,
    hasTackleTwill,
    berechnungsFeature,
    dpi,
    zuLoeschenBeiProduktUndDesignWechsel
}

type TextDataForBoundaryCrossing = {
    color,
    colorQuellpalette,
    fix,
    font,
    hasOutline,
    name,
    outlineColor,
    outlineColorQuellPalette,
    outlineZweiColor:number|string|null,
    outlineZweiColorPalette:string|null,
    characterSpacingProzent:number|null,
    outlineWidth,
    part,
    point,
    rotation,
    relSize,
    value,
    id,
    zIndex,
    isPinned,
    floating,
    keepSeparate,
    allowDrag,
    allowDelete,
    allowResize,
    isVorbelegung,
    ursprungsMotivID,
    hasTackleTwill,
    berechnungsFeature
};


type EntwurfDataForSaving = {
    design: string;
    derived_designliste: string;
    designname: string;
    model: string;
    saveID;
    derived_sport: string;
    username: string;
    warenkorb;
    designanfrage;
    cut: string;
    ordertype: string;
    realsport: string;
    designlist: string;
    produkt: string;
    schnitt: string;
    produktname: string;
    vorgaengerID;
    vorgaengerName: string;
    features;
    farbvariante;
    colors: Color[];
    logos: LogoDataForBoundaryCrossing[];
    textobjects: TextDataForBoundaryCrossing[];
    visible;
    patterns: PatternInEntwurf[],
    patternAnker: PatternAnkerContainer;
    tackletwillMoeglich:boolean;
    rdyDesignID: string;
    herstellerlogoEntfernt: boolean;
}


export class Entwurfpersistance {
    public model: IOwayoDataModel;
    private snapshotTaker: ISnapshotTaker;
    private selObInfoProvider: ISelObInfoProvider;
    private readonly isOM: boolean;


    constructor(model: IOwayoDataModel, snapshotViewComponent: ISnapshotTaker, selObInfoProvider: ISelObInfoProvider, isOM = false) {
        this.model = model;
        this.snapshotTaker = snapshotViewComponent;
        this.selObInfoProvider = selObInfoProvider;
        this.isOM = isOM;
    }

    prepareForEntwurfLoading(saveId: number, loadExemplare: boolean) {
        globalsObject.resourceManager.executeInvalidation("switchToExemplarErfassung");

        if (this.model.entwurf.getChangedSinceSave() === true) {
            EventVerteiler.broadcast(
                "displayDialogEvent",
                {
                    dialog: "saveBeforeDraftLoading",
                    callbacks: [
                        () => this.saveEntwurf().then(() => this.loadSavedEntwurf(saveId, loadExemplare)),
                        () => this.loadSavedEntwurf(saveId, loadExemplare)
                    ]
                }
            );
        } else {
            this.loadSavedEntwurf(saveId, loadExemplare);
        }
    }

    loadSavedEntwurf(saveId: number, loadExemplare: boolean) {
        Screenblocker.requestBlock("loadEntwurf");
        const $this = this;
        EventVerteiler.broadcast("loadSavedEntwurfEvent");

        globalsObject.resourceManager.executeInvalidation(ResourceInvalidationTriggers.PRODUCTCHANGE);

        globalsObject.resourceManager.registerResource({
            resourceName: "loadEntwurf.php",
            failHandler: function () {
                globalsObject.errorHandler.handleErrorTranslateMessage("ajaxFail", "loadSavedEntwurf", "konf_error_loadingDraft");

            },
            invalidatedWhen: ResourceInvalidationTriggers.PRODUCTCHANGE
        }).load({url: "/konfigurator_php/actionmodul/loadEntwurf.php?saveID=" + saveId + "&iso=" + $this.model.getSprache()});


        globalsObject.resourceManager.createTask("loadProdukte")
            .withContext(this)
            .invalidAfter(ResourceInvalidationTriggers.PRODUCTCHANGE)
            .when("loadEntwurf.php", "loaded")
            .thenDo(this.loadProdukteCallback);

        globalsObject.resourceManager.createTask("initOwayoProduct")
            .withContext(this)
            .invalidAfter(ResourceInvalidationTriggers.PRODUCTCHANGE)
            .when("loadEntwurf.php", "loaded")
            .andWhen("produkt.php", "loaded")
            .andWhen("loadProdukte", "done")
            .andWhen("stocklogos", "loaded")
            .thenDo(function (resourceData) {
                const loadEntwurfResource = typeof (resourceData["loadEntwurf.php"]) === "string" ? JSON.parse(resourceData["loadEntwurf.php"]) : resourceData["loadEntwurf.php"] as EntwurfFromDB;
                // $this.model.productStage.initAdditionalInfos(resourceData["produkt.php"], loadEntwurfResource.derived_sport,
                //     loadEntwurfResource.features);
                const product = Entwurfpersistance.getProduct(loadEntwurfResource);
                product.initAdditionalInfos(resourceData["produkt.php"], loadEntwurfResource.derived_sport,
                    loadEntwurfResource.features);
                // $this.model.productWebInt = resourceData["produkt.php"].Urlname;
                // $this.model.sportUnterDemDasProduktGefuehrtWird = resourceData["produkt.php"].Sport;
                EventVerteiler.broadcast("realsportChanged")
                $this.model.setCurrentOwayoProduct(product);
                if (resourceData["produkt.php"].VorgegebenerArtikel !== "") {
                    EventVerteiler.broadcast(SELOBTAB_EVENTNAMES.ACTIVATE_ARTIKEL_VIEW);
                } else {
                    EventVerteiler.broadcast(SELOBTAB_EVENTNAMES.ACTIVATE_PRODUCT_VIEW);
                }
                globalsObject.resourceManager.registerLoadedResourceWithoutData("initOwayoProductDone")

            });

        globalsObject.resourceManager.createTask("initLoadedEntwurf")
            .withContext(this)
            .invalidAfter(ResourceInvalidationTriggers.PRODUCTCHANGE)
            .when("initOwayoProduct", "done")
            .andWhen("loadEntwurf.php", "loaded")
            .thenDo(function (resourceData) {
                $this.processLoadedEntwurf(resourceData, loadExemplare);
                Screenblocker.releaseBlock("loadEntwurf");
            });
    }

    private static getPatternAnker() {
        return globalsObject.owayoJSViewer.getDroppableParts().reduce(function (ancors, p: OwayoKonfiPart) {
                ancors.setPosition(p.name, p.patternAnker);
                return ancors
            }
            , new PatternAnkerContainer()
        );

    }

    private isWrongBWColor() : boolean {
        if(arrayIndexByKeyValue(this.model.entwurf.getColorObjects(), 'colorCode', 'BW')<0){
            return false;

        }
        const bwColor = arrayElementByKeyValue(this.model.entwurf.getColorObjects(), 'colorCode', 'BW');
        const palette = (globalsObject.resourceManager.getResourceByName('palettenCluster_'+bwColor.palettenCluster).data[bwColor.palette]);

        return palette.filter((item) => ColorUtils.hexToDec(item.RGBHex) === bwColor.colorValue).length <= 0;
    }

    saveEntwurf(displayWarning = true, displayWarningText = "warningNotLoggedIn", visible = true) {
        if(this.isWrongBWColor()){
            EventVerteiler.broadcast("displayDialogEvent", {dialog: "errorInvalidBWColor"});
            EventVerteiler.broadcast("switchTabEvent", "farben");
            return new Promise<void>((resolve, reject) => {reject()});
        }
        else{
            return new Promise<void>((resolve, reject) => {
                const $this = this;
                if (this.model.user.isLoggedIn() === false && displayWarning === true) {
                    EventVerteiler.broadcast("displayNotLoggedInWarningEvent", displayWarningText);
                }
                this.model.entwurf.setCloneFlags();
                const sendObject = this.convertEntwurfToDBDesign();
                sendObject.visible = visible;
                EventVerteiler.broadcast("pleaseTakePicturesEventAndReturnThemToMe", (screenshots) => this.registerSaveDesignAsResource(sendObject, screenshots))
                // this.registerSaveDesignAsResource(sendObject);

                globalsObject.resourceManager.createTask("initSaveDesign")
                    .discardAfterExecution()
                    .when("saveEntwurfAs.php", "loaded")
                    .thenDo(function (resourceData) {
                        $this.entwurfWasSavedToDBCallback(resourceData).then(() => resolve())
                            .catch(() => {
                                EventVerteiler.broadcast("displayDialogEvent", {dialog: "errorSavingDraft"})
                                reject();
                            });
                    });

                EventVerteiler.broadcastBlockRequest("saveEntwurf");
            })
        }
    }

    private entwurfWasSavedToDBCallback(resourceData) {
        return new Promise<void>((resolve, reject) => {
            EventVerteiler.broadcastBlockRequestEnded("saveEntwurf");
            globalsObject.resourceManager.executeInvalidation("designSaved");

            if (resourceData["saveEntwurfAs.php"].status !== "success") {
                reject();
                return;
            }

            const derivedUserdataPath = resourceData["saveEntwurfAs.php"].derivedUserDataPath;
            const saveID = resourceData["saveEntwurfAs.php"].drafts[0].SaveID.toString();
            this.model.user.setDerivedUserDataPath(derivedUserdataPath);
            EventVerteiler.broadcast("derivedUserDataPathArrivedEvent", derivedUserdataPath);
            this.model.entwurf.setID(saveID);
            this.model.entwurf.setName(resourceData["saveEntwurfAs.php"].drafts[0].Name);
            this.model.user.addEntwurf(resourceData["saveEntwurfAs.php"].drafts[0]);
            this.model.entwurf.setChangedSinceSave(false);
            if (this.model.user.getEntwuerfe().length > 1) {
                EventVerteiler.broadcast("entwurfPreviewPictureSavedEvent", {
                    id: parseInt(this.model.entwurf.getID(), 10),
                    inBasket: this.model.entwurf.getInBasket()
                });
            } else {
                EventVerteiler.broadcast("updateEntwuerfeEvent", {
                    entwuerfe: this.model.user.getEntwuerfe(),
                });
            }
            this.model.entwurf.setChangedSinceSave(false);
            EventVerteiler.broadcast("displayHintEvent", {
                message: translate("konf_Hint_draftSaved", "Ihr Entwurf wurde gespeichert."),
                type: "ok"
            });
            resolve();
        })
    }

    public registerSaveDesignAsResource(sendObject: EntwurfDataForSaving, screenshots) {
        const $this = this;

        const desOb = {
            colors: sendObject.colors,
            textobjects: sendObject.textobjects,
            logos: sendObject.logos,
            patterns: sendObject.patterns,
            patternAnker: sendObject.patternAnker.anker
        };

        globalsObject.resourceManager.registerResource({
            resourceName: "saveEntwurfAs.php",
            failHandler: function () {
                globalsObject.errorHandler.handleErrorTranslateMessage("ajaxFail", "saveEntwurf", "konf_error_savingDraft");
            },
            invalidatedWhen: "designSaved"
        }).load({
            method: "POST",
            url: "/konfigurator_php/actionmodul/saveEntwurfAs.php",
            data: {
                designname: sendObject.designname,
                username: sendObject.username,
                derived_designliste: sendObject.derived_designliste,
                derived_sport: sendObject.derived_sport,
                model: sendObject.model,
                design: sendObject.design,
                designObj: JSON.stringify(desOb), //json, damit auch leere Arrays mit übertragen werden!!
                warenkorb: sendObject.warenkorb,
                cut: sendObject.cut,
                ordertype: sendObject.ordertype,
                realsport: sendObject.realsport,
                designlist: sendObject.designlist,
                produkt: sendObject.produkt,
                schnitt: sendObject.schnitt,
                produktname: sendObject.produktname,
                vorgaengerID: sendObject.vorgaengerID,
                vorgaengerName: sendObject.vorgaengerName,
                designanfrage: sendObject.designanfrage,
                land: $this.model.getSprache(),
                features: JSON.stringify(sendObject.features),
                uploadedByOwayo: $this.isOM,
                farbvariante: sendObject.farbvariante,
                visible: sendObject.visible,
                screenshots:JSON.stringify(screenshots),
                toCloud:DEBUG ? "true" : "false",
                renderLevel:CONSTANTS.SNAPSHOT_RENDER_LEVEL_1024_1024,
                tackletwillMoeglich: sendObject.tackletwillMoeglich,
                rdyDesignID: sendObject.rdyDesignID,
                herstellerlogosEntfernt: sendObject.herstellerlogoEntfernt,
                Frontend_TimestampInMilliSeconds:import.meta.env.VITE_BUILD_TIMESTAMP,
                Frontend_Appname:import.meta.env.VITE_APPNAME,
            }
        });
    }

    convertEntwurfToDBDesign(entwurfName = ""): EntwurfDataForSaving {
        // const entwurf = this.model.entwurf.getEntwurf();
        const product = this.model.getCurrentOwayoProduct();

        if (typeof (entwurfName) === "undefined") {
            entwurfName = "";
        }
        const previousEntwurf = arrayElementByKeyValue(this.model.user.getEntwuerfe(), "SaveID", parseInt(this.model.entwurf.getID(), 10));
        const previousName = previousEntwurf !== null ? previousEntwurf.Name : "";

        return {
            design: Entwurf.dataInteractor.getDesign(),
            derived_designliste: Entwurf.dataInteractor.getProductCategory(),
            designname: entwurfName,
            model: Entwurf.dataInteractor.getModel(),
            saveID: "",
            derived_sport: product.sportart,
            username: this.model.user.getUserName(),
            warenkorb: (Entwurf.dataInteractor.getInBasket() === true) ? "1" : "0",
            designanfrage: (Entwurf.dataInteractor.getDesignanfrage() === true) ? "1" : "0",
            cut: product.cut,
            ordertype: product.ordertype,
            realsport: product.realsport,
            designlist: product.designList,
            produkt: product.produkt,
            schnitt: product.schnitt,
            produktname: product.name,
            vorgaengerID: Entwurf.dataInteractor.getID(),
            vorgaengerName: previousName,
            features: product.selectedFeatures,
            farbvariante: Entwurf.dataInteractor.getFarbvariante(),
            colors: ColorController.convertColorsToDBFormat(Entwurf.dataInteractor.getColorObjects()),
            logos: this.convertLogosToDBFormat(),
            textobjects: this.convertTextObjectsToDBFormat(),
            visible: true,
            patterns: Entwurf.dataInteractor.getPatterns(),
            patternAnker: Entwurfpersistance.getPatternAnker(),
            tackletwillMoeglich: this.model.getCurrentOwayoProduct().TackleTwillMoeglich,
            rdyDesignID: Entwurf.dataInteractor.getRdyDesignID(),
            herstellerlogoEntfernt:Entwurf.dataInteractor.getHerstellerlogosDeleted(),
        };
    }

    static getTextObjectDataStructureForBoundaryCrossing(model: IOwayoDataModel, selObInfoProvider:ISelObInfoProvider, text: TextObject): TextDataForBoundaryCrossing {
        const textDim = selObInfoProvider.getAllTextObjectRelUVDimensions();
        const textDimEntry = arrayElementByKeyValue(textDim, "id", text.id);
        return {
            color: text.colorValue,
            colorQuellpalette: text.colorQuellPalette,
            fix: boolToInt(text.isFixed),
            font: text.font,
            hasOutline: (text.outlineColorValue === "<none>" ? 0 : 1),
            name: text.id,
            outlineColor: text.outlineColorValue,
            outlineColorQuellPalette: text.outlineColorValueQuellpalette,
            outlineZweiColor: text.outlineZweiColor,
            outlineZweiColorPalette: text.outlineZweiColorPalette,
            characterSpacingProzent: text.characterSpacingProzent,
            outlineWidth: (text.outlineColorValue === "<none>" ? 0 : text.outlineWidth / TextObject.getFontSize(text.value)),
            part: text.partName,
            point: textDimEntry.actualMiddleCoordOnPart,
            rotation: text.rotation.toString(),
            relSize: {x: textDimEntry.width, y: textDimEntry.height},
            value: text.value.trim(),
            id: text.id,
            zIndex: model.entwurf.getZOrderTable().getZIndex(text.id),
            isPinned: boolToInt(text.isPinned),
            floating: text.floating,
            keepSeparate: boolToInt(text.keepSeparate),
            allowDrag: boolToInt(text.allowDrag),
            allowDelete: boolToInt(text.allowDelete),
            allowResize: boolToInt(text.allowResize),
            isVorbelegung: boolToInt(text.isVorbelegung),
            ursprungsMotivID: text.ursprungsMotivID,
            hasTackleTwill: text.hasTackleTwill,
            berechnungsFeature: text.berechnungsFeature
        };
    }

    convertTextObjectsToDBFormat() {
        const textsToSave = this.model.entwurf.getTextObjects().filter(function (text: TextObject) {
            return !text.isClone && text.relSize.x > 0 && text.relSize.y > 0 && text.translation.x <= 1 && text.translation.y <= 1;
        });
        return Entwurfpersistance.convertTextListToDBFormat(this.model, this.selObInfoProvider, textsToSave);
    }

    static convertTextListToDBFormat(model: IOwayoDataModel, selObInfoProvider:ISelObInfoProvider, textsToSave) {
        return textsToSave.reduce(function (carry, text: TextObject) {
            carry.push(Entwurfpersistance.getTextObjectDataStructureForBoundaryCrossing(model, selObInfoProvider, text));
            return carry;
        }, [] as TextDataForBoundaryCrossing[]);
    }


    private static getLogoDataStructurForBoundaryCrossing(model:IOwayoDataModel, logo:Logo|ChromoLogo|StockLogo, logoNameInEntwurf: string): LogoDataForBoundaryCrossing {
        const zIndex = model.entwurf.getZOrderTable().getZIndex(logo.id);

        return {
            name: logoNameInEntwurf,
            part: logo.partName,
            pathToLogo: logo.pathToLogo,
            point: {x: logo.translation.x.toString(), y: logo.translation.y.toString()},
            rotation: logo.rotation.toString(),
            relSize: {x: logo.relSize.x.toString(), y: logo.relSize.y.toString()},
            zIndex: zIndex.toString(),
            chromoLogoId: logo.type === SelObTypes.CHROMOLOGO ? (logo as ChromoLogo).chromoLogoId : null,
            logoId: logo.type === SelObTypes.LOGO ? logo.logoId : null,
            stockLogoID: logo.type === SelObTypes.STOCKLOGO ? (logo as StockLogo).stockLogoID : null,
            repeat: boolToInt(logo.repeat),
            clampToColor: logo.clampToColor,
            wasserzeichen: boolToInt(logo.wasserzeichen),
            wasserzeichenInvertImage: boolToInt(logo.wasserzeichenInvertImage),
            wasserzeichenIntensity: logo.wasserzeichenIntensity,
            isPinned: boolToInt(logo.isPinned),
            floating: logo.floating,
            keepSeparate: boolToInt(logo.keepSeparate),
            allowDrag: boolToInt(logo.allowDrag),
            allowDelete: boolToInt(logo.allowDelete),
            allowResize: boolToInt(logo.allowResize),
            allowColorChange: SelObTypes.isEinfaerbbaresLogo(logo.type) ? boolToInt((logo as ChromoLogo | StockLogo).allowColorChange) : true,
            colors: SelObTypes.isEinfaerbbaresLogo(logo.type) ? Entwurfpersistance.removeFarbKopplungIsColorChangedFromStockLogoColors((logo as ChromoLogo | StockLogo).colors) : null,
            isEinfaerbbar: SelObTypes.isEinfaerbbaresLogo(logo.type) ? "1" : "0",
            isVorbelegung: boolToInt(logo.isVorbelegung),
            ursprungsMotivID: logo.ursprungsMotivID,
            hasTackleTwill: logo.hasTackleTwill,
            berechnungsFeature: logo.berechnungsFeature,
            dpi: logo.dpi,
            zuLoeschenBeiProduktUndDesignWechsel: typeof ((logo as StockLogo).zuLoeschenBeiProduktUndDesignWechsel) !== "undefined" ?
                boolToInt((logo as StockLogo).zuLoeschenBeiProduktUndDesignWechsel)
                : 0
        }
    }

    private static removeFarbKopplungIsColorChangedFromStockLogoColors(colors:ChromoLogoColor[]):ChromoLogoColor[] {
        return colors.map(c=>{
            if(c.kopplungAufgehoben) {
                c.kopplungAnColorCode = null;
            }
            return c;
        })
    }

    convertLogosToDBFormat() {

        const logosToSave = this.model.entwurf.getLogoObjects().filter(function (logo: Logo) {
            return !logo.isClone && logo.relSize.x > 0 && logo.relSize.y > 0;
        });
        return this.convertLogoListToDBFormat(this.model, logosToSave);

    }

    convertLogoListToDBFormat(model:IOwayoDataModel, logosToSave:Logo[]) {
        return logosToSave.reduce(function (carry, logo: Logo, currentIndex) {
            carry.push(Entwurfpersistance.getLogoDataStructurForBoundaryCrossing(model, logo, "Logo_" + (currentIndex + 1)));
            return carry;
        }, [] as LogoDataForBoundaryCrossing[]);
    }


    deleteSavedEntwurf(saveID: number) {
        $.ajax({
            type: "POST",
            url: "/konfigurator_php/actionmodul/deleteEntwurf.php",
            data: {saveID: saveID}
        })
            .fail(function () {
                globalsObject.errorHandler.handleErrorTranslateMessage("ajaxFail", "deleteSavedEntwurf", "konf_error_deletingDraft");
            })
            .done(function (data) {
                if(data==="draftInShop"){
                    EventVerteiler.broadcast("displayDialogEvent", {dialog: "draftInShop"});
                }
                else if(data==="draftIsRdyDesign"){
                    EventVerteiler.broadcast("displayDialogEvent", {dialog: "draftIsRdyDesign"});
                }
                else{
                    EventVerteiler.broadcast("entwurfDeletedEvent", saveID);
                }
            });

    }

    private static parseAsJSONIfNecessary(s) {
        return typeof (s) === "string" ? JSON.parse(s) : s;
    }

    loadProdukteCallback(resourceData) {
        const loadDesignResource = Entwurfpersistance.parseAsJSONIfNecessary(resourceData["loadEntwurf.php"]) as EntwurfFromDB;
        const sportChanged = this.model.getWebsportFuerProduktAuswahlNormalized() !== loadDesignResource.derived_sport;
        this.model.setWebsportFuerProduktAuswahlNormalized(loadDesignResource.derived_sport);
        this.model.setWebsportFuerProduktAuswahlInt(loadDesignResource.derived_sportInt);
        if (sportChanged) {
            globalsObject.resourceManager.executeInvalidation(ResourceInvalidationTriggers.SPORT_CHANGED);
            this.model.setWebsportFuerProduktAuswahlNormalized(loadDesignResource.derived_sport);
            globalsObject.productController.produkte = ProductController.getNewProductList(loadDesignResource.derived_sport);
            globalsObject.productController.produkte.setController(globalsObject.productController);
            globalsObject.productController.produkte.loadProdukte();
        }
        const data = {
            schnitt: loadDesignResource.schnitt,
            sport: loadDesignResource.realsport,
            websport: this.model.getWebsportFuerProduktAuswahlNormalized(),
            // sportAnzeigeKategorie: this.model.sportUnterDemDasProduktGefuehrtWird,
            ordertype: loadDesignResource.ordertype,
            webProduct: loadDesignResource.derived_designliste,
            iso: this.model.getLanguageIso(),
            produktAuwi: loadDesignResource.produkt,
            showUnpublishedDesigns: this.isOM,
            features: JSON.stringify(loadDesignResource.features)
        };
        globalsObject.resourceManager.registerResource({
            resourceName: "produkt.php",
            invalidatedWhen: ResourceInvalidationTriggers.PRODUCTCHANGE
        })
            .load({
                    method: "POST",
                    url: "/konfigurator_php/auswahlmodul/produkt.php",
                    data: data
                }
            );
        globalsObject.resourceManager.createTask("initEntwurfProdukt").discardAfterExecution().when("produkt.php", "loaded").thenDo(()=>{

        })
    }

    private static getProduct(loadDesignResource) {
        return new Product(
            loadDesignResource.produkt,
            loadDesignResource.produktname,
            loadDesignResource.cut,
            loadDesignResource.ordertype,
            loadDesignResource.realsport,
            loadDesignResource.designlist
        );
    }

    processLoadedEntwurf(resourceData, loadExemplare: boolean) {
        globalsObject.controller.initLoadedEntwurf(resourceData["loadEntwurf.php"], resourceData["loadEntwurf.php"].saveID);
        EventVerteiler.broadcast(
            "updateTitelTagEvent",
            {
                product: this.model.getCurrentOwayoProduct(),
                design: resourceData["loadEntwurf.php"].design
            }
        );

        if (loadExemplare === true) {
            EventVerteiler.broadcast("createDatainputEvent", {});
            EventVerteiler.broadcast("activateExemplarErfassungEvent", {});
        }
        //EinzelexemplarViewComponent.setSizesExplanationProduktSpezifisch(resourceData["loadEntwurf.php"].produkt);
    }

    duplicateEntwurfIntoWarenkorb(saveID: string) {
        const $this = this;
        EventVerteiler.broadcastBlockRequest("entwurfDuplication");
        $.get("/konfigurator_php/actionmodul/duplicateEntwurf.php", {
            username: this.model.user.getUserName(),
            saveid: saveID,
            inwarenkorb: 1
        }, function () {
            EventVerteiler.broadcastBlockRequestEnded("entwurfDuplication");
            EventVerteiler.broadcast(GLOBALEVENTNAMES.LOAD_WARENKORBDATA, {
                sprache: $this.model.getSprache(),
                land: $this.model.getLand()
            });
            EventVerteiler.broadcast(GLOBALEVENTNAMES.WARENKORBPOSITION_CHANGED);
            // Action Buttons anpassen
            $(".right-side").removeClass("change-item");
            $(".hide-when-warenkorbdesignchange").removeClass("ele-hidden");
        })
    }
}
